module.exports = __webpack_public_path__ + "img/info-circle.706c1973.svg";